import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { AppLayoutComponent } from './layout/app.layout.component';
import { DashboardComponent } from './plateformebeneficiaire/components/dashboard/dashboard.component';
import { LandingComponent } from './plateformebeneficiaire/components/landing/landing.component';
import { MeetingsComponent } from './plateformebeneficiaire/components/meetings/meetings.component';
import { MyProfileComponent } from './plateformebeneficiaire/components/myprofile/myprofile.component';
import { TodolistComponent } from './plateformebeneficiaire/components/todolist/todolist.component';
import { DocumentsComponent } from './plateformebeneficiaire/components/documents/documents.component';
import { LoginCallbackComponent } from './plateformebeneficiaire/components/auth/callback/login-callback.component';
import { ErrorPageComponent } from './plateformebeneficiaire/components/error/error-page.component';
import { TranslationService } from './layout/service/app.translation.service';
import { LogoutCallbackComponent } from './plateformebeneficiaire/components/auth/callback/logout-callback.component';
import { NewsComponent } from './plateformebeneficiaire/components/news/news.component';
import { PrepareMeetingAiComponent } from './plateformebeneficiaire/components/meetings/prepare-meeting-ai/prepare-meeting-ai.component';

export let APP_ROUTES: Routes = [];

export let APP_ROUTES_MENU: any = {};

export async function loadRoutes(): Promise<void> {
  const translation = inject(TranslationService);
  const translations = await firstValueFrom(translation.loadTranslations());

  APP_ROUTES = [
    {
      path: '',
      component: LandingComponent,
    },
    {
      path: 'confidentialite',
      loadComponent: () => import('./plateformebeneficiaire/components/politique-confidentialite/politique-confidentialite.component').then(m => m.PolitiqueConfidentialiteComponent),
      data: {
        breadcrumb: 'Confidentialité',
        label: 'Politique de confidentialité',
        icon: 'pi pi-shield',
      },
    },
    {
      path: 'app',
      component: AppLayoutComponent,
      children: [
        {
          path: '',
          component: DashboardComponent,
          data: {
            breadcrumb: translations.homepage.breadcrumb,
            label: translations.homepage.label,
            icon: translations.homepage.icon,
          },
        },
        {
          path: 'confidentialite',
          loadComponent: () => import('./plateformebeneficiaire/components/politique-confidentialite/politique-confidentialite.component').then(m => m.PolitiqueConfidentialiteComponent),
          data: {
            breadcrumb: 'Confidentialité',
            label: 'Politique de confidentialité',
            icon: 'pi pi-shield',
          },
        },
        {
          path: 'prepare-meeting-ai',
          component: PrepareMeetingAiComponent,
          data: {
            breadcrumb: translations.ai_meetings.breadcrumb,
            label: translations.ai_meetings.label,
            icon: translations.ai_meetings.icon,
          },
        },
        {
          path: 'meetings',
          component: MeetingsComponent,
          data: {
            breadcrumb: translations.meetings.breadcrumb,
            label: translations.meetings.label,
            icon: translations.meetings.icon,
          },
        },
        {
          path: 'taches',
          component: TodolistComponent,
          data: {
            breadcrumb: translations.todolist.breadcrumb,
            label: translations.todolist.label,
            icon: translations.todolist.icon,
          },
        },
        {
          path: 'mysettings',
          component: MyProfileComponent,
          data: {
            breadcrumb: translations.myprofile.breadcrumb,
            label: translations.myprofile.label,
            icon: translations.myprofile.icon,
          },
        },
        {
          path: 'documents',
          component: DocumentsComponent,
          data: {
            breadcrumb: translations.documents.breadcrumb,
            label: translations.documents.label,
            icon: translations.documents.icon,
          },
        },
        {
          path: 'articles',
          component: NewsComponent,
          data: {
            breadcrumb: translations.news.breadcrumb,
            label: translations.news.label,
            icon: translations.news.icon,
          },
        },
      ],
    },
    {
      path: 'auth',
      children: [
        { path: 'callback', component: LoginCallbackComponent },
        { path: 'logoutcallback', component: LogoutCallbackComponent },
      ],
    },
    { path: 'error', component: ErrorPageComponent },
    { path: '**', redirectTo: '/notfound' },
  ];

  APP_ROUTES_MENU = {
    homepage: {
      label: translations.homepage.label,
      icon: translations.homepage.icon,
      breadcrumb: translations.homepage.breadcrumb,
      routerLink: ['/app'],
    },
    profile: {
      label: translations.myprofilelabel,
      icon: translations.myprofile.icon,
      breadcrumb: translations.myprofile.breadcrumb,
      routerLink: ["/app/mysettings"],
    },
    meetings: {
      label: translations.meetings.label,
      icon: translations.meetings.icon,
      breadcrumb: translations.meetings.breadcrumb,
      routerLink: ["/app/meetings"],
    },
    todolist: {
      label: translations.todolist.label,
      icon: translations.todolist.icon,
      breadcrumb: translations.todolist.breadcrumb,
      routerLink: ["/app/taches"],
    },
    documents: {
      label: translations.documents.label,
      icon: translations.documents.icon,
      breadcrumb: translations.documents.breadcrumb,
      routerLink: ["/app/documents"],
    },
    news: {
      label: translations.news.label,
      icon: translations.news.icon,
      breadcrumb: translations.news.breadcrumb,
      routerLink: ["/app/articles"],
    },
    myprofile: {
      label: translations.myprofile.label,
      first_display_label: translations.myprofile.first_display_label,
      icon: translations.myprofile.icon,
      breadcrumb: translations.myprofile.breadcrumb,
      routerLink: ["/app/mysettings"],
    }
  };
}
